import { h, Component, Fragment } from 'preact';

class VideoScroller extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoIdx: 0,
        };
        this.videoScrollerRef = null;
    }

    trackCarouselScroll = (newIdx) => {
        const { stores, id: articleId, files = [] } = this.props;
        if (stores && stores.appState && articleId && files.length > 1) {
            stores.appState.addUsageLog({
                type: 'feed_video_carousel_scroll',
                props: {
                    articleId,
                    videoIndex: newIdx,
                    totalVideos: files.length,
                    direction: 'swipe',
                },
                timestamp: Math.floor(new Date().getTime() / 1000),
            });
        }
    }

    onScroll = (e) => {
        const { files = [] } = this.props;
        if (files.length === 0) {
            return;
        }
        const { scrollLeft, clientWidth } = e.target;
        const videoIdxRaw = scrollLeft / clientWidth;
        const nearestInt = Math.round(videoIdxRaw);
        const diff = Math.abs(nearestInt - videoIdxRaw);
        if (Number.isInteger(videoIdxRaw) || diff < 0.1) {
            if (this.state.videoIdx !== nearestInt) {
                this.setState({ videoIdx: nearestInt });
                this.trackCarouselScroll(nearestInt);
            }
        }
    }

    render() {
        const { files = [], renderSlide } = this.props;
        const { videoIdx } = this.state;
        return (
            <div class='w-100 position-relative'>
                <div
                    class='d-flex flex-row flex-nowrap no-scrollbar'
                    style='overflow-x: auto; overflow-y: hidden; scroll-snap-type: x mandatory;'
                    onScroll={this.onScroll}
                    ref={c => this.videoScrollerRef = c}
                >
                    {files.map((file, idx) => (
                        <div
                            key={`video-scroller-${file.s3LinkStream || file.s3Link || idx}`}
                            class='w-100 flex-shrink-0'
                            style='scroll-snap-align: start;'
                        >
                            {renderSlide(file, idx === videoIdx)}
                        </div>
                    ))}
                </div>
                {files.length > 1 && <>
                    <div
                        class='position-absolute text-white px-1 py-1 rounded-lg'
                        style='top: 15px; left: 15px; background-color: rgba(0, 0, 0, 0.25); line-height: 1.0em; z-index: 2;'
                    >
                        <small>{videoIdx + 1} / {files.length}</small>
                    </div>
                    {/* Dots sit below the slides, not overlaid: the video player's
                        control bar occupies the bottom edge of each slide. */}
                    <div class='w-100 text-center'>
                        <small>
                            <small>
                                {files.map((file, idx) => (
                                    <i key={`video-scroller-dot-${idx}`} class={`${idx === videoIdx ? 'fa-solid' : 'fa-regular'} fa-circle me-1 text-body-secondary`} />
                                ))}
                            </small>
                        </small>
                    </div>
                </>}
            </div>
        );
    }
}

export default VideoScroller;
